module.exports = __webpack_public_path__ + "img/Image_0.625b25df.jpg";